import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ServiceHelper } from 'src/app/core/helper/services.helper';

@Component({
  selector: 'app-html-editor',
  templateUrl: './html-editor.component.html',
  styleUrls: ['./html-editor.component.scss'],
})
export class HtmlEditorModal implements OnInit {
  
  @Input() html: string;
  @Input() maxLength: number = 5000;

  inProgressHtml: string;

  constructor(private modalCtrl: ModalController) { 
  }

  async ngOnInit() {
    this.inProgressHtml = this.html;
  }

  async apply(){
    this.html = this.inProgressHtml;
    this.modalCtrl.dismiss({html: this.html});
  }
  
  async discard() {
    if ( this.html == this.inProgressHtml){
      this.dismiss()
    }else if ( await ServiceHelper.confirmSomething('Discard Changes and Close?', 'Do you want to discard your changes and close the modal?')) {
      this.dismiss();
    }
  }

  async revert() {
    if ( this.html != this.inProgressHtml && await ServiceHelper.confirmSomething('Discard Changes?', 
                        'Do you want to discard your changes and close the modal?')) {
      this.inProgressHtml = this.html;
    }
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

}
